/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginPostResponse
 */
export interface LoginPostResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginPostResponse
     */
    refresh: string;
    /**
     * 
     * @type {string}
     * @memberof LoginPostResponse
     */
    access: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginPostResponse
     */
    isNewUser: boolean;

    result: boolean;
	
    type: string;	

    /**
     * Пока звонка не было: через сколько секунд можно запросить код по SMS (0 - уже можно, null - окно звонка истекло)
     * @type {number | null}
     * @memberof LoginPostResponse
     */
    smsAvailableIn?: number | null;
}

export function LoginPostResponseFromJSON(json: any): LoginPostResponse {
    return LoginPostResponseFromJSONTyped(json, false);
}

export function LoginPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginPostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
	if(json['result']){
		return {
			
			'refresh': json['refresh'],
			'access': json['access'],
			'result': json['result'],
			'type': json['type'],
			'isNewUser': json['isNewUser'],
		};
	}
	else{
		return {
			'result': json['result'],
			'type': json['type'],
			'refresh': null,
			'access': null,
			'isNewUser': null,
			'smsAvailableIn': json['smsAvailableIn'],
		};		
		
	}
}

export function LoginPostResponseToJSON(value?: LoginPostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'refresh': value.refresh,
        'access': value.access,
        'isNewUser': value.isNewUser,
        'type': value.type,
        'result': value.result,
    };
}


